const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, useProgress } = window.BAO.Carousel.plugins

class ProductMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return
    if (this.els.slide.elements.length <= 1) return

    this.carousel = this.setupCarousel()

    if (!this.els?.thumbnails?.exists) return
    this.thumbnailCarousel = this.setupThumbnailCarousel()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.thumbnails?.exists) {
      this.handleThumbnailTrigger = this.handleThumbnailTrigger.bind(this)

      this.els.thumbnailtrigger.elements.forEach((thumbnailtriggerEl) => {
        this.listeners.add(
          thumbnailtriggerEl,
          'click',
          this.handleThumbnailTrigger,
        )
      })
    }
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 5,
        },
        slideChanged: this.onSlideChanged,
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        useProgress({
          container: this.els?.progress?.element,
          progressbar: this.els?.progressbar?.element,
        }),
      ],
    )
  }

  onSlideChanged (instance) {
    if (!this.els?.thumbnails?.exists) return

    const currentSlide = instance.track.details.rel

    this.els?.thumbnail?.elements.forEach((thumbnail, index) => {
      thumbnail.setAttribute('aria-current', index === currentSlide)
    })

    if (this.thumbnailCarousel) this.thumbnailCarousel.moveToIdx(currentSlide)

    if (this.els?.zoom?.exists) {
      this.els.zoom.element.setAttribute('data-index', currentSlide)

      const activeSlide = this.querySelector(
        `${this.els?.slide?.selector}[data-index="${currentSlide}"]`,
      )

      if (activeSlide) {
        const mediaType = activeSlide.getAttribute('data-media-type')

        if (mediaType === 'video') {
          const videoIndex = activeSlide.getAttribute('data-video-index')
          this.els.zoom.element.setAttribute(
            'data-video-gallery-external-el',
            'trigger',
          )
          this.els.zoom.element.setAttribute('data-video-index', videoIndex)
        } else {
          this.els.zoom.element.removeAttribute(
            'data-video-gallery-external-el',
          )
          this.els.zoom.element.removeAttribute('data-video-index')
        }
      }
    }
  }

  setupThumbnailCarousel () {
    return new KeenSlider(
      this.els?.thumbnails?.element,
      {
        selector: this.els?.thumbnail?.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 5,
        },
        vertical: true,
      },
      [setInitialised()],
    )
  }

  handleThumbnailTrigger (e) {
    const thumbnailTrigger = e.target.closest(
      `${this.els.thumbnailtrigger.selector}`,
    )

    const targetIndex = parseInt(thumbnailTrigger.dataset.index, 10)

    this.carousel.moveToIdx(targetIndex)
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
